import React from 'react'

import { ServiceHealthStateTema } from 'src/dto'
import styled from 'styled-components'

const Container = styled.span<{ cor: string; corFundo: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background: ${({ corFundo }) => corFundo};
  color: ${({ cor }) => cor};
`

const Ponto = styled.span<{ cor: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ cor }) => cor};
`

interface BadgeEstadoProps {
  tema: ServiceHealthStateTema
}

/** Badge de estado/resultado: mapeia o tema (label + cor) vindo do DTO. */
export const BadgeEstado: React.FC<BadgeEstadoProps> = ({ tema }) => (
  <Container cor={tema.cor} corFundo={tema.corFundo}>
    <Ponto cor={tema.cor} />
    {tema.label}
  </Container>
)
